import React,{createContext,useContext,useEffect,useState} from 'react';
export const THEME_KEY='segmira.theme';
const ThemeContext=createContext(null);
export function readTheme(){try{return window.localStorage.getItem(THEME_KEY)==='dark'?'dark':'light';}catch{return 'light';}}
export function ThemeProvider({children}){
 const [theme,setTheme]=useState(readTheme);
 useEffect(()=>{document.documentElement.dataset.theme=theme;try{window.localStorage.setItem(THEME_KEY,theme);}catch{}},[theme]);
 useEffect(()=>{const sync=e=>{if(e.key===THEME_KEY||e.key===null)setTheme(readTheme());};window.addEventListener('storage',sync);return()=>{window.removeEventListener('storage',sync);delete document.documentElement.dataset.theme;};},[]);
 return <ThemeContext.Provider value={{theme,toggleTheme:()=>setTheme(t=>t==='dark'?'light':'dark')}}>{children}</ThemeContext.Provider>;
}
export const useTheme=()=>useContext(ThemeContext)||{theme:'light',toggleTheme:()=>{}};
